import { AddonAndQuantity } from '@app/react/components/calendar/newReservation/NewReservationTypes';

export const INITIAL_RESERVATION_ADDON: AddonAndQuantity = { quantity: 0 };
export const INITIAL_RESERVATION_ADDONS: AddonAndQuantity[] = [INITIAL_RESERVATION_ADDON];
export const RESERVATION_ADDONS = 'reservationAddons';
